export default __webpack_public_path__ + "static/media/ic-card-print.df52c910.svg";